import { render } from "./votingPerItem.vue?vue&type=template&id=28d6db6e"
import script from "./votingPerItem.vue?vue&type=script&lang=js"
export * from "./votingPerItem.vue?vue&type=script&lang=js"

import "./votingPerItem.vue?vue&type=style&index=0&id=28d6db6e&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__